import { Injectable } from '@angular/core';
import { TcemsService } from '../api/tcems.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { selectCurrentUser, selectTwilioReservation, selectUserState } from '../state/app.state';
import { User, UserState } from '../model/util/user';
import { ReservationAccepted, ReservationCancelled, ReservationCreated, ReservationRejected, ReservationTimeout, ReservationWrapup, WorkerReady, WorkerStatusChanged } from '../actions/twilio.actions';
import { BehaviorSubject } from 'rxjs';
import { updateUserState } from '../actions/api/tcems.actions';
import { Task } from '../model/comm/Task';

@Injectable({
  providedIn: 'root'
})
export class TwilioService {

  constructor(private tcemsService: TcemsService,
    private store: Store ) 
  { 

    this.reservation$.subscribe
    (
      r =>
      {
        this.reservation = r.reservation;
      }
    );

    //Keep user state up to date with the store
  
    this.userState$.subscribe(
      us =>
      {
        if(us != null)
        {
          this.currentState = Object.assign(new UserState(), us);
        }
      }
    )

    this.currentUser$.subscribe(
      u => 
      {
        if(u != null)
        {
          this.currentUser = Object.assign(new User(),u); 
          if ( this.currentUser.twilioWorkerSid != null )
          {

            this.tcemsService.getWorkspaceSid( "nurses" ).toPromise().then
            (
              workspaceSid => {
                this.workspaceSid = workspaceSid["token"];
                if ( this.workspaceSid != null ) {
                  this.bindTaskRouter();
                }
              }
            );
          }

        }
      });
  }

  worker: any;
  voice: any;
  activitySids: {name:string,sid:string}[];
  workspaceSid: string;

  currentUser$ = this.store.select(selectCurrentUser);
  currentUser : User;

  userState$ = this.store.select(selectUserState);
  currentState: UserState;

  reservation$ = this.store.select(selectTwilioReservation);
  reservation: any;
  reservationStatus: string;

  private twilioNumber = new BehaviorSubject<string>("");
  currentTwilioNumber = this.twilioNumber.asObservable();

  updateTwilioNumber( _twilioNumber: string )
  {
    this.twilioNumber.next( _twilioNumber );
  }

  async bindTaskRouter() : Promise<void> { 

    return this.tcemsService.getTaskRouterCapabilityToken( this.workspaceSid, this.currentUser.twilioWorkerSid ).toPromise().then
    (

      token => {
        this.worker = new Twilio.TaskRouter.Worker( token.token );
        this.worker.activities.fetch
        (
          (error, activityList) => 
          {
            this.activitySids = activityList.data.map(d => ({sid:d.sid, name:d.friendlyName}));

            //Set the current worker status
            this.store.dispatch({type: WorkerStatusChanged.type,workerStatus:this.worker.activityName});

            //Set up events for this worker
            this.worker.on('ready', (worker) => 
              {
                this.store.dispatch({type: WorkerReady.type,worker:worker});
                this.store.dispatch({type: WorkerStatusChanged.type,workerStatus:worker.activityName});
              });
            this.worker.on('activity.update', (worker) => this.store.dispatch({type: WorkerStatusChanged.type,workerStatus:worker.activityName}));
            this.worker.on('reservation.created', (reservation) => this.store.dispatch({type: ReservationCreated.type,reservation:reservation}));
            this.worker.on('reservation.accepted', (reservation) => this.store.dispatch({type: ReservationAccepted.type,reservation:reservation}));
            this.worker.on('reservation.rejected', (reservation) => this.store.dispatch({type: ReservationRejected.type,reservation:reservation}));
            this.worker.on('reservation.timeout', (reservation) => this.store.dispatch({type: ReservationTimeout.type,reservation:reservation}));
            this.worker.on('reservation.canceled', (reservation) => this.store.dispatch({type: ReservationCancelled.type,reservation:reservation}));
            this.worker.on('reservation.wrapup', (reservation) => this.store.dispatch({type: ReservationWrapup.type,reservation:reservation}));
          }
        )
        
      }
    )
  }

  MakeWorkerReady(workerSid=null)
  {
    if (workerSid == null) {
      this.worker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Ready").sid});
      if ( this.currentState.activeTask != null && this.currentState.activeTask.externalId != null) 
      {
        let t = this.currentState.activeTask;
        this.tcemsService.hangupConversation(t.externalId, parseInt(t.attributes["conversationId"]));
        let us = Object.assign(new UserState(), this.currentState);
        us.activeTask = null;
        this.store.dispatch({type: updateUserState.type, userState: us});
      }
    } else {  // Updating presence status for another user
      this.tcemsService.getTaskRouterCapabilityToken( this.workspaceSid, workerSid ).toPromise().then
      (
        token => {
          let tempWorker = new Twilio.TaskRouter.Worker( token.token );
          tempWorker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Ready").sid});
        }
      );
    }
  }

  MakeWorkerAway(workerSid=null)
  {
    if (workerSid == null) {
      this.worker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Away").sid});
    } else {  // Updating presence status for another user
      this.tcemsService.getTaskRouterCapabilityToken( this.workspaceSid, workerSid ).toPromise().then
      (
        token => {
          let tempWorker = new Twilio.TaskRouter.Worker( token.token );
          tempWorker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Away").sid});
        }
      );
    }
  }

  MakeWorkerDesk(workerSid=null)
  {
    if (workerSid == null) {
      this.worker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Desk").sid});
    } else {  // Updating presence status for another user
      //getJWT();
      this.tcemsService.getTaskRouterCapabilityToken( this.workspaceSid, workerSid ).toPromise().then
      (
        token => {
          let tempWorker = new Twilio.TaskRouter.Worker( token.token );
          tempWorker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Desk").sid});
        }
      );
    }
  }
  
  MakeWorkerBusy(workerSid=null)
  {
    if (workerSid == null) {
      this.worker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Busy").sid});
    } else {  // Updating presence status for another user
      this.tcemsService.getTaskRouterCapabilityToken( this.workspaceSid, workerSid ).toPromise().then
      (
        token => {
          let tempWorker = new Twilio.TaskRouter.Worker( token.token );
          tempWorker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Busy").sid});
        }
      );
    }
  }
  
  MakeWorkerVacation(workerSid=null)
  {
    if (workerSid == null) {
      this.worker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Vacation").sid});
    } else {  // Updating presence status for another user
      this.tcemsService.getTaskRouterCapabilityToken( this.workspaceSid, workerSid ).toPromise().then
      (
        token => {
          let tempWorker = new Twilio.TaskRouter.Worker( token.token );
          tempWorker.update({"ActivitySid": this.activitySids.find((a) => a.name == "Vacation").sid});
        }
      );
    }
  }
  
  MakeWorkerAcceptReservation()
  {
    if ( ( this.currentState.activeTask == null || this.currentState.activeTask.externalId == null ) && this.reservation.reservationStatus == "pending" )
    {
      this.tcemsService.acceptTask( this.reservation.taskSid );

      let us = Object.assign(new UserState(), this.currentUser.userState);

      us.activeTask = Object.assign(new Task(), this.reservation.task);
      us.activeTask.externalId = this.reservation.task.sid;

      this.store.dispatch({type: updateUserState.type, userState: us});

    }
    else if ( this.currentState.activeTask != null && this.currentState.activeTask.externalId != null) 
    {

      let t = this.currentState.activeTask;
      this.tcemsService.hangupConversation(t.externalId, parseInt(t.attributes["conversationId"]));

      let us = Object.assign(new UserState(), this.currentState);

      us.activeTask = null;

      this.store.dispatch({type: updateUserState.type, userState: us});

    } else {
      // ignore the click
    }
  }
  isChat: boolean;
}